/**
 * src/utils/undoRedo/commands/DrawCommand.js
 * Çizim nesnesi ekleme/kaldırma komutu
 * Desteklenen tipler: line, circle, arc, ellipse, rect, polyline, spline, text, mtext
 */

import BaseCommand from './BaseCommand';
import { clearSelection } from '../../../redux/selectionSlice';

class DrawCommand extends BaseCommand {
  /**
   * @param {THREE.Object3D} objectRef - Sahneye eklenen Three.js nesnesi
   */
  constructor(objectRef) {
    super('DRAW_OBJECT', {
      before: null,
      after: { id: objectRef.userData.id, type: objectRef.userData.type }
    });
    this.objectRef = objectRef;
  }

  /**
   * Redo: Nesneyi sahneye geri ekle
   */
  execute(scene, dispatch) {
    scene.add(this.objectRef);
    if (dispatch) dispatch(clearSelection());
  }

  /**
   * Undo: Nesneyi sahneden kaldır (dispose etmeden!)
   */
  undo(scene, dispatch) {
    scene.remove(this.objectRef);
    if (dispatch) dispatch(clearSelection());
  }
}

export default DrawCommand;
